import { html, LitElement } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';

@customElement('read-more')
export class ReadMore extends LitElement {

    // Props

    @property({ type: Boolean, reflect: true })
    expanded: boolean = false;

    @state()
    _html: string = '';

    // Lifecycle Hooks

    connectedCallback() {
        super.connectedCallback();
        this.classList.add('ReadMore');
    }

    firstUpdated() {
        const slot: HTMLElement | null = this.querySelector('[slot="html"]');
        if (slot) {
            this._html = slot.innerHTML;
            slot.remove();
        }
    }

    // Render

    render() {
        return html`
            <div class="ReadMore-body u-BodyText" ?hidden="${ !this.expanded }">
                ${ unsafeHTML(this._html) }
            </div>
            <button class="ReadMore-button" name="toggle" @click="${ this._toggle }">
                ${ this.expanded ? 'Read Less' : 'Read More' }
            </button>
        `;
    }

    createRenderRoot() { 
        return this;
    }

    // Methods

    private _toggle() {
        this.expanded = !this.expanded;
    }

}